import React from 'react';
import { Modal, Input, Form, Select, Switch, message, Tabs, Button, Tooltip, Divider, InputNumber, DatePicker, Radio, TreeSelect } from 'antd';
import moment from "moment";

import File from './File';
import global from '../../../common/utility/global';
import { FORMAT_2DECIMALS, FORMAT_5DECIMALS, GREATER_THAN_ZERO } from '../../../common/types/regularExpresionType';
import { LOGISTICA_PRODUCTOS_CON_LOTE } from '../../../common/types/parametroType'
import auth from '../../../common/utility/auth';
import dialog from "../../../common/utility/dialog";

const { Option } = Select;
const InputGroup = Input.Group;

const { TabPane } = Tabs;
let id = 0;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            idVariantes: ""
        }
    }

    handleAutocompleteCuentaContableVenta = async (value) => {
        const result = this.props.formValues.planesCuenta.filter(item => {
            return (item.cuentaContable + ' - ' + item.nombre).toUpperCase().match(value.toUpperCase());
        }).slice(0, 75);
        this.props.form.setFieldsValue({ cuentasContablesVenta: result });
    };

    handleAutocompleteCuentaContableCompra = async (value) => {
        const result = this.props.formValues.planesCuenta.filter(item => {
            return (item.cuentaContable + ' - ' + item.nombre).toUpperCase().match(value.toUpperCase())
        }).slice(0, 75);
        this.props.form.setFieldsValue({ cuentasContablesCompra: result });
    };

    complete2Decimals = (e) => {
        if (e.target.value === '' || isNaN(parseFloat(e.target.value).toFixed(5)))
            this.props.form.setFieldsValue({ peso: '0.00000' });
        else
            this.props.form.setFieldsValue({ peso: parseFloat(e.target.value).toFixed(5) });
    }

    handleChangeFile = async (event) => {
        var file = event.target.files[0];
        if (!file)
            return;

        var fileExtension = file.name.split('.')[1];
        var fileSize = Math.floor(file.size / 1024);
        var allowedExtensions = ['jpeg', 'jpg', 'png'];

        if (allowedExtensions.filter(m => { return m === fileExtension }).length === 0) {
            message.error('Solo puede subir archivos: ' + allowedExtensions.join(' / ') + '.');
            return;
        }

        if (fileSize > 5120) {
            message.error('Tamaño máximo permitido ' + parseFloat(parseFloat(fileSize / 1024).toFixed(2)).toString() + ' mb.');
            return;
        }

        this.props.form.setFieldsValue({ nombreArchivo: file.name, icon: 'loading' });

        var response = await this.props.onUploadFile(file);

        if (response.status !== 200) {
            message.error('Ocurrió un error al intentar subir el archivo.');
            this.handleRemoveFile();
            return;
        }

        this.props.form.setFieldsValue({ icon: 'folder-open', url: response.data.url });
    }

    handleRemoveFile = () => {
        global.cleanInputFile(this.props.form.getFieldValue('identifier'), this.handleChangeFile);
        this.props.form.setFieldsValue({ url: '', nombreArchivo: '', icon: 'folder-open' });
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleBarcode = async (values) => {
        this.props.onBarcode(this.props.form, values);
    }


    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {

                const form = {
                    id: values.id,
                    nombre: values.nombre,
                    modelo: values.modelo,
                    codigoReferencia: values.codigoReferencia,
                    codigoBarra: values.flagVariante == 0 ? values.codigoBarra : null,
                    idUnidadMedida: values.idUnidadMedida.key,
                    idExistencia: values.idExistencia ? values.idExistencia.key : 0,
                    idExistenciaCatalogo: values.idExistenciaCatalogo ? values.idExistenciaCatalogo.key : 0,

                    idMarca: values.idMarca ? values.idMarca.key : 0,
                    idPlanCuentaVenta: values.idPlanCuentaVenta ? values.idPlanCuentaVenta.key : 0,
                    idPlanCuentaCompra: values.idPlanCuentaCompra ? values.idPlanCuentaCompra.key : 0,
                    idProductoSunat: values.idProductoSunat ? values.idProductoSunat.key : 0,
                    idProductoNivel: values.idProductoCate ? values.idProductoCate : 0,
                    arancelaria: values.arancelaria,

                    peso: parseFloat(parseFloat(values.peso).toFixed(5)),
                    stockMin: parseFloat(parseFloat(values.stockMin).toFixed(2)),
                    stockMax: parseFloat(parseFloat(values.stockMax).toFixed(2)),
                    idModelo: values.idModelo ? values.idModelo.key : 0,
                    idImpuesto: values.idImpuesto ? values.idImpuesto.key : null,
                    url: values.url,
                    nombreArchivo: values.nombreArchivo,
                    flagIGVAfecto: values.flagIGVAfecto,
                    flagExonerado: values.flagExonerado,
                    flagISC: values.flagISC,
                    flagGratuito: values.flagGratuito,
                    flagICBPER: values.flagICBPER,
                    flagNormalizado: values.flagNormalizado,
                    flagVencimiento: values.flagVencimiento,
                    //jsonAtributos: JSON.stringify(values.valuesAtributo),
                    jsonAtributos: this.fetchAtributos(values),
                    flagVariante: values.flagVariante == 0 ? false : true,
                    flagAplicarSerie: values.flagAplicarSerie,
                }

                if (form.stockMin > 0 && form.stockMax == 0) {
                    dialog.warning("Stock Max debe ser mayor 0.");
                    return false;
                }

                if (form.stockMax > 0) {
                    if (form.stockMin >= form.stockMax) {
                        dialog.warning("Stock Max debe ser mayor a Stock Min.");
                        return false;
                    }
                }

                if (values.flagVariante == 1) {
                    if (this.props.formValues.varianteItemSelected.length == 0) {
                        dialog.warning("Se tiene que agregar variante!");
                        return false;
                    }

                    var jsonVariante = this.fetchVariantes(form);
                    if (jsonVariante.length > 0) {
                        this.props.onSave(jsonVariante, this.props.form);
                    }

                } else {
                    this.props.onSave(form, this.props.form);

                }
            }
        });
    }

    fetchVariantes = (values) => {
        var result = [];
        const codigosBarra = new Set();
        let repetido = false;

        this.props.formValues.varianteItemSelected.forEach((row) => {

            var _codigoBar = this.props.form.getFieldValue(`variant[${row.identifier}]`);

            if (codigosBarra.has(_codigoBar)) {
                repetido = true;
                return false;
            }

            // Agregar el código de barras al conjunto
            codigosBarra.add(_codigoBar);

            result.push({
                idAtributoItem: row.idAtributoItem,
                idAtributo: row.idAtributo,
                id: values.id,
                nombre: values.nombre + "-" + row.nombre,
                descripcion: values.nombre + "-" + row.nombre,
                codigoReferencia: values.codigoReferencia,
                codigoBarra: this.props.form.getFieldValue(`variant[${row.identifier}]`),
                idUnidadMedida: values.idUnidadMedida,
                idExistencia: values.idExistencia,
                idMarca: values.idMarca,
                idPlanCuentaVenta: values.idPlanCuentaVenta,
                idPlanCuentaCompra: values.idPlanCuentaCompra,
                idProductoSunat: values.idProductoSunat,
                peso: values.peso,
                stockMin: values.stockMin,
                stockMax: values.stockMax,
                idModelo: values.idModelo,
                codigoImpuesto: values.codigoImpuesto,
                url: values.url,
                nombreArchivo: values.nombreArchivo,
                flagIGVAfecto: values.flagIGVAfecto,
                flagExonerado: values.flagExonerado,
                flagISC: values.flagISC,
                flagGratuito: values.flagGratuito,
                flagICBPER: values.flagICBPER,
                flagVencimiento: values.flagVencimiento,
                flagVariante: values.flagVariante,
                flagAplicarSerie: values.flagAplicarSerie,
                jsonAtributos: values.jsonAtributos,

            });
        });
        if (repetido) {
            dialog.warning("¡No se puede repetir el código de barras!");
            result = [];
        }

        return result;
    };

    fetchAtributos = (values) => {
        var item = {};
        var keys = [];
        var obj = Object.assign({}, values.valorInput);

        for (var [key] of Object.entries(obj)) {
            keys.push(key);
        }

        keys.forEach((key, i) => {
            var codigo = values.keys[i].codigoAtri;
            var edit = values.keys[i].edit;

            var idAtributo = values.keys[i].idAtributo;
            var tipo_campo = null;
            i++;

            switch (codigo) {
                case "FE":
                    tipo_campo = values.namesInput[key].format("DD/MM/YYYY");
                    break;
                case "LI":
                    tipo_campo = edit ? values.namesInput[key] : values.valorInput[key];
                    break;
                case "DE":
                    tipo_campo = parseFloat(values.namesInput[key]);
                    break;
                case "NU":
                    tipo_campo = parseInt(values.namesInput[key]);

                    break;
                case "TE":
                    tipo_campo = values.namesInput[key];

                    break;
                default:
                    tipo_campo = values.namesInput[key];
                    break;
            }

            item["idAtributo" + i] = idAtributo;
            item["atributo" + i] = tipo_campo;


        });


        return JSON.stringify(item);
    };

    handleValueChange = (property, value, identifier, idAtributo) => {

        const { form } = this.props;
        var _valor = property == "BO" ? value ? "SI" : "NO" : value;

        // can use data-binding to set
        // important! notify form to detect changes
        form.setFieldsValue({
            [`valorInput[${identifier}]`]: _valor,
        });
    };

    handleonChange(valor, codigo) {
        this.props.form.setFieldsValue({ codigoAtri: codigo });

        if (codigo == "LI") {
            this.props.onChangeForm("LI", valor, this.props.form)
        }
    }

    remove = k => {
        const { form } = this.props;
        // can use data-binding to get
        const keys = form.getFieldValue('keys');

        // can use data-binding to set
        form.setFieldsValue({
            keys: keys.filter(key => key.identifier !== k),
        });


    };

    add = () => {
        const { form } = this.props;
        var otroImpuesto = this.props.form.getFieldValue("idAtributo");
        var codigoAtri = this.props.form.getFieldValue("codigoAtri");
        var tipo_campo = null;
        var valor = null;
        const identifier = global.fetchUniqueCode();
        const valuesAtributo = form.getFieldValue('keys');

        var item_existe = valuesAtributo.filter(key => key.idAtributo == otroImpuesto.key);

        if (item_existe.length > 0) {
            dialog.error("No se puede duplicar los Atributos!");
            return false;
        }

        switch (codigoAtri) {
            case "FE":
                tipo_campo =
                    <DatePicker
                        onChange={(moment, value) => this.handleValueChange(codigoAtri, value, identifier, otroImpuesto.key)}
                        style={{ width: '90%', marginRight: 8 }} />
                valor = global.fetchCurrentDateStr(true)
                break;
            case "LI":
                tipo_campo =
                    <Select
                        placeholder="Seleccione Item"
                        style={{ width: '90%', marginRight: 8 }}
                        optionFilterProp="children"
                        onChange={(value, option) =>
                            this.handleValueChange(codigoAtri, option.props.nombre, identifier, otroImpuesto.key)
                        }
                    >
                        {this.props.formValues.atributoItem.map((item) => (
                            <Option key={item.id} value={item.id} nombre={item.nombre}>{item.nombre}</Option>
                        ))}
                    </Select>
                break;
            case "DE":
                tipo_campo =
                    <InputNumber
                        placeholder="Ingrese valor"
                        onBlur={(e) => this.handleValueChange(codigoAtri, e.target.value, identifier, otroImpuesto.key)}
                        min={0}
                        step={0.2}
                        style={{ width: '90%', marginRight: 8 }} />
                valor = 0;

                break;
            case "NU":
                tipo_campo =
                    <InputNumber
                        placeholder="Ingrese valor"
                        onBlur={(e) => this.handleValueChange(codigoAtri, e.target.value, identifier, otroImpuesto.key)}
                        min={0}
                        style={{ width: '90%', marginRight: 8 }} />
                valor = 0;
                break;
            case "TE":
                tipo_campo =
                    <Input
                        placeholder="Ingrese valor"
                        onBlur={(e) => this.handleValueChange(codigoAtri, e.target.value, identifier, otroImpuesto.key)}
                        style={{ width: '90%', marginRight: 8 }} />
                valor = null;
                break;
            default:
                tipo_campo = <Switch
                    checkedChildren="SI"
                    unCheckedChildren="NO"
                    onChange={(e) => this.handleValueChange(codigoAtri, e, identifier, otroImpuesto.key)}
                    style={{ width: '10%', marginRight: 8 }} />
                valor = false;
                break;
        }

        if (otroImpuesto == undefined) {
            dialog.error("Seleccione un Atributo!");
            return false;
        }

        // can use data-binding to get 
        const keys = form.getFieldValue('keys');


        const nextKeys = keys.concat({
            identifier: identifier,
            idAtributo: otroImpuesto.key,
            label: otroImpuesto.label,
            input: tipo_campo,
            codigoAtri: codigoAtri,
            value: valor,
            edit: false
        });


        form.setFieldsValue({
            keys: nextKeys,
        });
    };

    handleChange = (value) => {
        this.props.onChangeForm("idVariantes", value, this.props.form)
    }

    handleOpen = () => {

        if (this.props.formValues.idVariantes == null || this.props.formValues.idVariantes.length == 0) {
            dialog.error("Seleccione variantes!");
            return false;
        }
        this.props.openModal(this.props.formValues.idVariantes, this.props.form)
    };
    handleInput = (data) => {
        var tipo_campo = null;
        if (data.codigoAtri == "LI") {
            this.props.onChangeForm("LI", data.idAtributo, this.props.form)
        }

        switch (data.codigoAtri) {
            case "FE":
                tipo_campo =
                    <DatePicker
                        onChange={(moment, value) => this.handleValueChange(data.codigoAtri, value, data.identifier, data.idAtributo)}
                        style={{ width: '90%', marginRight: 8 }} />
                break;
            case "LI":
                tipo_campo =
                    <Select
                        placeholder="Seleccione Item"
                        style={{ width: '90%', marginRight: 8 }}
                        optionFilterProp="children"
                        onChange={(value, option) =>
                            this.handleValueChange(data.codigoAtri, option.props.nombre, data.identifier, data.idAtributo)
                        }
                    >
                        {this.props.formValues.atributoItem.map((item) => (
                            <Option key={item.id} value={item.id} nombre={item.nombre}>{item.nombre}</Option>
                        ))}
                    </Select>
                break;
            case "DE":
                tipo_campo =
                    <InputNumber
                        placeholder="Ingrese valor"
                        onBlur={(e) => this.handleValueChange(data.codigoAtri, e.target.value, data.identifier, data.idAtributo)}
                        min={0}
                        step={0.2}
                        style={{ width: '90%', marginRight: 8 }} />
                break;
            case "NU":
                tipo_campo =
                    <InputNumber
                        placeholder="Ingrese valor"
                        onBlur={(e) => this.handleValueChange(data.codigoAtri, e.target.value, data.identifier, data.idAtributo)}
                        min={0}
                        style={{ width: '90%', marginRight: 8 }} />
                break;
            case "TE":
                tipo_campo =
                    <Input
                        placeholder="Ingrese valor"
                        onBlur={(e) => this.handleValueChange(data.codigoAtri, e.target.value, data.identifier, data.idAtributo)}
                        style={{ width: '90%', marginRight: 8 }} />
                break;
            default:
                tipo_campo = <Switch
                    checkedChildren="SI"
                    unCheckedChildren="NO"
                    onChange={(e) => this.handleValueChange(data.codigoAtri, e, data.identifier, data.idAtributo)}
                    style={{ width: '10%', marginRight: 8 }} />
                break;
        }
        return tipo_campo;
    };

    onLoadData = treeNode =>
        new Promise(resolve => {
            const { id } = treeNode.props;
            setTimeout(() => {
                this.props.onData(id)
                resolve();
            }, 100);
        });

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('codigoAtri', { initialValue: "" });

        getFieldDecorator('cuentasContablesVenta', {
            initialValue: this.props.formValues.cuentasContablesVenta
                .filter(m => { return m.id === this.props.formValues.idPlanCuentaVenta })
        });
        getFieldDecorator('cuentasContablesCompra', {
            initialValue: this.props.formValues.cuentasContablesCompra
                .filter(m => { return m.id === this.props.formValues.idPlanCuentaCompra })
        });

        getFieldDecorator('identifier', { initialValue: 'file-1' });
        getFieldDecorator('url', { initialValue: this.props.formValues.url });
        getFieldDecorator('nombreArchivo', { initialValue: this.props.formValues.nombreArchivo });
        getFieldDecorator('icon', { initialValue: 'folder-open' });
        getFieldDecorator('planCuentaVentaIcon', { initialValue: 'search' });
        const mostrarVencimeinto = auth.user().parametros.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;
        getFieldDecorator('flagVariante', { initialValue: this.props.formValues.variante });

        // dinamyc input

        getFieldDecorator('valuesAtributo', { initialValue: this.props.formValues.valuesAtributo });

        getFieldDecorator('keys', { initialValue: this.props.formValues.keysAtributo });

        const keys = getFieldValue('keys');

        const formItems = keys.map((k, index) => (
            <div className="col-md-9 form-group">
                <Form.Item
                    label={k.label}
                    required={false}
                    key={k.identifier}
                >
                    {getFieldDecorator(`namesInput[${k.identifier}]`, {
                        validateTrigger: ['onChange'],
                        initialValue: k.codigoAtri == "FE" ? moment(k.value, "DD/MM/YYYY") : k.value,
                        rules: [{
                            required: true,
                            message: "Campo obligatorio.",
                        }],
                    })(k.input)}
                    {keys.length >= 1 ? (
                        <Tooltip placement="top" title="Eliminar">
                            <Button
                                type="danger"
                                icon="delete"
                                size={"small"}
                                onClick={() => this.remove(k.identifier)}
                            />
                        </Tooltip>
                    ) : null}
                    {getFieldDecorator(`valorInput[${k.identifier}]`, {
                        initialValue: k.value,
                    })(
                        <Input hidden />
                    )}
                </Form.Item>
            </div>
        ));

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 20 },
            },
        };

        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Producto" : "Modificar Producto"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
                width="800px"
            >
                <Form>

                    <div className="row">
                        <Tabs
                            activeKey={this.props.formValues.activeKey}
                            onChange={(key) => this.props.onChangeTab(key, null)}

                        >
                            <TabPane tab="Datos Productos" key="1">
                                <div className="row">

                                    {this.props.formValues.id == 0 ?
                                        <div className="col-md-12 form-group">
                                            <div className="col-md-12 form-group">
                                                <Form.Item>
                                                    {getFieldDecorator('flagVariante', {
                                                        initialValue: this.props.formValues.variante
                                                    })(
                                                        <Radio.Group name="radiogroup"
                                                            onChange={(e) => this.props.onChangeForm("flagVariante", e.target.value, this.props.form)}
                                                        >
                                                            <Radio value={0}>Producto sin variante</Radio>
                                                            <Radio value={1}>Producto con variante</Radio>
                                                        </Radio.Group>
                                                    )}
                                                </Form.Item>
                                            </div>
                                        </div> : null
                                    }

                                    <div className="col-md-6 form-group">
                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Nombre">
                                                {getFieldDecorator('nombre', {
                                                    initialValue: this.props.formValues.nombre,
                                                    rules: [{
                                                        required: true,
                                                        message: 'Campo obligatorio.',
                                                        whitespace: true
                                                    }]
                                                })(
                                                    <Input
                                                        placeholder="Ingresar Nombre"
                                                        autoComplete="off"
                                                    />
                                                )}
                                            </Form.Item>
                                        </div>

                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Código referencia">
                                                {getFieldDecorator('codigoReferencia', {
                                                    initialValue: this.props.formValues.codigoReferencia
                                                })(
                                                    <Input
                                                        placeholder="Ingresar Código Referencia"
                                                        autoComplete="off"
                                                    />
                                                )}
                                            </Form.Item>
                                        </div>

                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Marca">
                                                {getFieldDecorator('idMarca', {
                                                    initialValue: this.props.formValues.idMarca ?
                                                        { key: this.props.formValues.idMarca } : undefined
                                                })(
                                                    <Select showSearch labelInValue
                                                        placeholder={"Seleccione Marca"}
                                                        optionFilterProp="children"
                                                    >
                                                        {this.props.formValues.marcas.map(item => (
                                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                        ))}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </div>

                                        <div className="col-md-7 form-group">
                                            <Form.Item label="Peso (KG)">
                                                {getFieldDecorator('peso', {
                                                    initialValue: parseFloat(this.props.formValues.peso).toFixed(5),
                                                    rules: [{
                                                        pattern: new RegExp(FORMAT_5DECIMALS),
                                                        message: "Formato decimal incorrecto (0.00000)"
                                                    }]
                                                })(
                                                    <Input
                                                        className="text-right"
                                                        placeholder="Ingresar peso"
                                                        autoComplete="off"
                                                        onKeyPress={global.onKeyPressDecimals}
                                                        onBlur={(e) => {
                                                            this.props.form.setFieldsValue({
                                                                peso: global.onBlurDecimals(e, 5)
                                                            });
                                                        }}
                                                    />
                                                )}
                                            </Form.Item>
                                        </div>

                                        <div className="col-md-12 form-group">

                                            <div className="row">

                                                <div className="col-md-5 form-group">
                                                    <Form.Item label="Aplica Vencimiento">
                                                        {getFieldDecorator('flagVencimiento', {
                                                            initialValue: this.props.formValues.flagVencimiento,
                                                            valuePropName: 'checked'
                                                        })(
                                                            <Switch checkedChildren="SI" unCheckedChildren="NO"
                                                                disabled={!mostrarVencimeinto}
                                                                onChange={(e) => this.props.onChangeForm("flagVencimiento", e, this.props.form)}
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </div>


                                                <div className="col-md-5 form-group">
                                                    <Form.Item label="Bien Normalizado">
                                                        {getFieldDecorator('flagNormalizado', {
                                                            initialValue: this.props.formValues.flagNormalizado,
                                                            valuePropName: 'checked'
                                                        })(
                                                            <Switch checkedChildren="SI" unCheckedChildren="NO"

                                                                onChange={(e) => this.props.onChangeForm("flagNormalizado", e, this.props.form)}
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </div>

                                        {auth.user().parametros.filter((m) => m.abreviatura == "SERP")[0].valor == "1" ? (
                                            <div className="col-md-7 form-group">
                                                <Form.Item label="Aplicar Serie">
                                                    {getFieldDecorator('flagAplicarSerie', {
                                                        initialValue: this.props.formValues.flagAplicarSerie,
                                                        valuePropName: 'checked'
                                                    })(
                                                        <Switch checkedChildren="SI" unCheckedChildren="NO"
                                                            disabled={this.props.formValues.id > 0 ? true : false}
                                                            onChange={(e) => this.props.onChangeForm("flagAplicarSerie", e, this.props.form)}
                                                        />
                                                    )}
                                                </Form.Item>
                                            </div>
                                        ) : null}

                                    </div>
                                    <div className="col-md-6 form-group">

                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Unidad de Medida">
                                                {getFieldDecorator('idUnidadMedida', {
                                                    initialValue: this.props.formValues.idUnidadMedida ?
                                                        { key: this.props.formValues.idUnidadMedida } : undefined,
                                                    rules: [{
                                                        required: true,
                                                        message: 'Campo obligatorio.',
                                                    }]
                                                })(
                                                    <Select showSearch labelInValue
                                                        placeholder={"Seleccione Unidad de Medida"}
                                                        optionFilterProp="children"
                                                    >
                                                        {this.props.formValues.unidadesMedida.map(item => (
                                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                        ))}
                                                    </Select>
                                                )}
                                            </Form.Item>

                                        </div>
                                        <div className="col-md-12 form-group">
                                            {this.props.form.getFieldValue("flagVariante") == 0 ?
                                                <Form.Item label="Código de barra">
                                                    <InputGroup compact>
                                                        {getFieldDecorator('codigoBarra', {
                                                            initialValue: this.props.formValues.codigoBarra
                                                        })(
                                                            <Input
                                                                style={{ width: `calc(100% - 40px)` }}
                                                                placeholder="Ingresar Código de Barra"
                                                                autoComplete="off"
                                                                maxLength={30}
                                                            />
                                                        )}
                                                        <Tooltip placement="top" title={"Generar Codigo de Barra"}>
                                                            <Button
                                                                className="btn-autocomplete"
                                                                style={{ width: '40px', fontSize: '14px' }}
                                                                icon={'barcode'}
                                                                onClick={() => this.handleBarcode(null)}
                                                            />
                                                        </Tooltip>
                                                    </InputGroup>
                                                </Form.Item>
                                                : null
                                            }
                                        </div>
                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Modelo">
                                                {getFieldDecorator('modelo', {
                                                    initialValue: this.props.formValues.modelo
                                                })(
                                                    <Input
                                                        placeholder="Ingresar Modelo"
                                                        autoComplete="off"
                                                    />
                                                )}
                                            </Form.Item>
                                        </div>

                                        <div className="col-md-12 form-group" hidden >
                                            <Form.Item label="Categoria">
                                                {getFieldDecorator('idModelo', {
                                                    initialValue: this.props.formValues.idModelo ?
                                                        { key: this.props.formValues.idModelo } : undefined
                                                })(
                                                    <Select showSearch labelInValue
                                                        placeholder={"Seleccione Modelo"}
                                                        optionFilterProp="children"
                                                    >
                                                        {this.props.formValues.modelos.map(item => (
                                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                        ))}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </div>

                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Existencia">
                                                {getFieldDecorator('idExistencia', {
                                                    initialValue: this.props.formValues.idExistencia ?
                                                        { key: this.props.formValues.idExistencia } : undefined
                                                })(
                                                    <Select showSearch labelInValue
                                                        placeholder={"Seleccione Existencia"}
                                                        optionFilterProp="children"
                                                    >
                                                        {this.props.formValues.existencias.map(item => (
                                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                        ))}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </div>

                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Catálogo Existencia">
                                                {getFieldDecorator('idExistenciaCatalogo', {
                                                    initialValue: this.props.formValues.idExistenciaCatalogo ?
                                                        { key: this.props.formValues.idExistenciaCatalogo } : undefined
                                                })(
                                                    <Select showSearch labelInValue
                                                        placeholder={"Seleccione Catálogo  Existencia"}
                                                        optionFilterProp="children"
                                                    >
                                                        {this.props.formValues.catalogoexistencias.map(item => (
                                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                        ))}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </div>
                                        <div className="col-md-12 form-group">

                                            <Form.Item label="Partida Arancelaria">
                                                {getFieldDecorator('arancelaria', {
                                                    initialValue: this.props.formValues.arancelaria
                                                })(
                                                    <Input
                                                        placeholder="Partida Arancelaria"
                                                        autoComplete="off"
                                                    />
                                                )}
                                            </Form.Item>
                                        </div>

                                        <div className="col-md-12 form-group" hidden>
                                            <Form.Item label="Imagen">
                                                <File
                                                    identifier={getFieldValue('identifier')}
                                                    filename={getFieldValue('nombreArchivo')}
                                                    downloadUrl={getFieldValue('url')}
                                                    icon={getFieldValue('icon')}
                                                    onChange={this.handleChangeFile}
                                                    onRemove={this.handleRemoveFile}
                                                />
                                            </Form.Item>
                                        </div>

                                    </div>

                                    <div className="col-md-12 form-group">
                                        <Divider orientation="left">Clasificación del Producto</Divider>
                                    </div>

                                    <div className="col-md-6 form-group">
                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Categoria">
                                                {getFieldDecorator('idProductoCate', {
                                                    initialValue: this.props.formValues.idProductoCate == 0 ? '' : this.props.formValues.idProductoCate
                                                })(
                                                    <TreeSelect
                                                        treeDataSimpleMode
                                                        searchPlaceholder=''
                                                        allowClear
                                                        treeDefaultExpandAll={this.props.formValues.id > 0 ? true : false}
                                                        style={{ width: '100%' }}
                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                        placeholder="Categoria"
                                                        loadData={this.onLoadData}
                                                        treeData={this.props.formValues.segmentoCategoria}
                                                    />
                                                )}
                                            </Form.Item>
                                        </div>


                                    </div>

                                    <div className="col-md-12 form-group">
                                        <Divider orientation="left">Características del Impuesto</Divider>
                                    </div>

                                    <div className="col-md-6 form-group">
                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Tipo de afectación">
                                                {getFieldDecorator('idImpuesto', {
                                                    initialValue: this.props.formValues.idImpuesto ?
                                                        { key: this.props.formValues.idImpuesto } : undefined,
                                                    rules: [{
                                                        required: true,
                                                        message: 'Campo obligatorio.',
                                                    }]
                                                })(
                                                    <Select showSearch labelInValue
                                                        placeholder={"Seleccione afectación"}
                                                        optionFilterProp="children"
                                                        disabled={this.props.form.getFieldValue('flagICBPER')}
                                                        onChange={(option) => this.props.onChangeForm("idImpuesto", option.key, this.props.form)}

                                                    >
                                                        {this.props.formValues.tipoAfectacion.map(item => (
                                                            ['10', '20', '30', '40'].includes(item.codigoSunat) ?
                                                                <Option key={item.id} value={item.id}>{item.nombre}</Option> :
                                                                null))}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </div>
                                    </div>


                                    <div className="col-md-6 form-group" hidden>
                                        <div className="col-md-12 form-group">
                                            <div className="row">

                                                <div className="col-md-4 form-group">
                                                    <Form.Item label="Gratuito">
                                                        {getFieldDecorator('flagGratuito', {
                                                            initialValue: this.props.formValues.flagGratuito,
                                                            valuePropName: 'checked'
                                                        })(
                                                            <Switch checkedChildren="SI" unCheckedChildren="NO"
                                                                onChange={(e) => this.props.onChangeForm("flagGratuito", e, this.props.form)}
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </div>


                                                <div className="col-md-4 form-group">
                                                    <Form.Item label="ICBPER">
                                                        {getFieldDecorator('flagICBPER', {
                                                            initialValue: this.props.formValues.flagICBPER,
                                                            valuePropName: 'checked'
                                                        })(
                                                            <Switch checkedChildren="SI" unCheckedChildren="NO"
                                                                onChange={(e) => this.props.onChangeForm("flagICBPER", e, this.props.form)}
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </div>

                                                <div className="col-md-4 form-group">

                                                </div>
                                            </div>

                                        </div>


                                    </div>

                                    <div className="col-md-12 form-group">
                                        <Divider orientation="left">Stock</Divider>
                                    </div>

                                    <div className="col-md-6 form-group">
                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Stock Mínimo">
                                                {getFieldDecorator('stockMin', {
                                                    initialValue: parseFloat(this.props.formValues.stockMin).toFixed(2),
                                                    rules: [{
                                                        pattern: new RegExp(FORMAT_2DECIMALS),
                                                        message: "Formato decimal incorrecto (0.00)"
                                                    }]
                                                })(
                                                    <Input
                                                        className="text-right"
                                                        placeholder="Ingresar stock Min"
                                                        autoComplete="off"
                                                        onKeyPress={global.onKeyPressDecimals}
                                                        onBlur={(e) => {
                                                            this.props.form.setFieldsValue({
                                                                stockMin: global.onBlurDecimals(e, 2)
                                                            });
                                                        }}
                                                    />
                                                )}
                                            </Form.Item>
                                        </div>
                                    </div>

                                    <div className="col-md-6 form-group">
                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Stock Maximo">
                                                {getFieldDecorator('stockMax', {
                                                    initialValue: parseFloat(this.props.formValues.stockMax).toFixed(2),
                                                    rules: [{
                                                        pattern: new RegExp(FORMAT_2DECIMALS),
                                                        message: "Formato decimal incorrecto (0.00)"
                                                    }]
                                                })(
                                                    <Input
                                                        className="text-right"
                                                        placeholder="Ingresar Stock Maximo"
                                                        autoComplete="off"
                                                        onKeyPress={global.onKeyPressDecimals}
                                                        onBlur={(e) => {
                                                            this.props.form.setFieldsValue({
                                                                stockMax: global.onBlurDecimals(e, 2)
                                                            });
                                                        }}
                                                    />
                                                )}
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>


                            </TabPane>

                            <TabPane tab="Contabilidad" key="2">
                                <div className="row">

                                    <div className="col-md-12 form-group">
                                        <Divider orientation="left">Configuración Contable</Divider>
                                    </div>
                                    <div className="col-md-6 form-group">
                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Cuenta Contable Venta">
                                                <InputGroup compact>
                                                    {getFieldDecorator('idPlanCuentaVenta', {
                                                        initialValue: this.props.formValues.idPlanCuentaVenta ? { key: this.props.formValues.idPlanCuentaVenta } : undefined
                                                    })(
                                                        <Select showSearch labelInValue
                                                            style={{ width: `calc(100% - 40px)` }}
                                                            placeholder={"Búsqueda de Cuenta Contable venta"}
                                                            optionFilterProp="children"
                                                            showArrow={false}
                                                            onSearch={this.handleAutocompleteCuentaContableVenta}
                                                        >
                                                            {this.props.formValues.cuentasContablesVenta.map(item => (
                                                                <Option key={item.id} value={item.id}>{item.cuentaContable + ' - ' + item.nombre}</Option>
                                                            ))}
                                                        </Select>
                                                    )}
                                                    <Button
                                                        className="btn-autocomplete"
                                                        style={{ width: '40px', fontSize: '14px' }}
                                                        icon={this.props.form.getFieldValue('idPlanCuentaVenta') ? 'close' : 'search'}
                                                        onClick={() => this.props.form.setFieldsValue({ idPlanCuentaVenta: undefined })}
                                                    />
                                                </InputGroup>
                                            </Form.Item>
                                        </div>
                                    </div>

                                    <div className="col-md-6 form-group">
                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Cuenta Contable Compra">
                                                <InputGroup compact>
                                                    {getFieldDecorator('idPlanCuentaCompra', {
                                                        initialValue: this.props.formValues.idPlanCuentaCompra ? { key: this.props.formValues.idPlanCuentaCompra } : undefined
                                                    })(
                                                        <Select showSearch labelInValue
                                                            style={{ width: `calc(100% - 40px)` }}
                                                            placeholder={"Búsqueda de Cuenta Contable Compra"}
                                                            optionFilterProp="children"
                                                            showArrow={false}
                                                            onSearch={this.handleAutocompleteCuentaContableCompra}
                                                        >
                                                            {this.props.formValues.cuentasContablesCompra.map(item => (
                                                                <Option key={item.id} value={item.id}>{item.cuentaContable + ' - ' + item.nombre}</Option>
                                                            ))}
                                                        </Select>
                                                    )}
                                                    <Button
                                                        className="btn-autocomplete"
                                                        style={{ width: '40px', fontSize: '14px' }}
                                                        icon={this.props.form.getFieldValue('idPlanCuentaCompra') ? 'close' : 'search'}
                                                        onClick={() => this.props.form.setFieldsValue({ idPlanCuentaCompra: undefined })}
                                                    />
                                                </InputGroup>
                                            </Form.Item>
                                        </div>
                                    </div>

                                    <div className="col-md-12 form-group">
                                        <Divider orientation="left">Código de producto SUNAT (UNSPSC)</Divider>
                                    </div>
                                    <div className="col-md-6 form-group">
                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Segmento (SUNAT)">
                                                {getFieldDecorator('idSegmentoSunat', {
                                                    initialValue: this.props.formValues.idSegmentoSunat ?
                                                        { key: this.props.formValues.idSegmentoSunat } : undefined
                                                })(
                                                    <Select showSearch labelInValue
                                                        placeholder={"Seleccione Segmento"}
                                                        optionFilterProp="children"
                                                        onChange={(option) => {
                                                            this.props.form.setFieldsValue({ idFamiliaSunat: undefined, idClaseSunat: undefined, idProductoSunat: undefined });
                                                            this.props.onChangeForm("idSegmentoSunat", option.key)
                                                        }}


                                                    >
                                                        {this.props.formValues.segmentosSunat.map(item => (
                                                            <Option key={item.id} value={item.id}>{item.descripcion}</Option>
                                                        ))}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </div>

                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Familia (SUNAT)">
                                                {getFieldDecorator('idFamiliaSunat', {
                                                    initialValue: this.props.formValues.idFamiliaSunat ?
                                                        { key: this.props.formValues.idFamiliaSunat } : undefined
                                                })(
                                                    <Select showSearch labelInValue
                                                        placeholder={"Seleccione Familia"}
                                                        optionFilterProp="children"
                                                        onChange={(option) => {
                                                            this.props.form.setFieldsValue({ idClaseSunat: undefined, idProductoSunat: undefined });
                                                            this.props.onChangeForm("idFamiliaSunat", option.key)
                                                        }}
                                                    >
                                                        {this.props.formValues.familiasSunat.map(item => (
                                                            <Option key={item.id} value={item.id}>{item.descripcion}</Option>
                                                        ))}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </div>
                                    </div>

                                    <div className="col-md-6 form-group">
                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Clase (SUNAT)">
                                                {getFieldDecorator('idClaseSunat', {
                                                    initialValue: this.props.formValues.idClaseSunat ?
                                                        { key: this.props.formValues.idClaseSunat } : undefined
                                                })(
                                                    <Select showSearch labelInValue
                                                        placeholder={"Seleccione Clase"}
                                                        optionFilterProp="children"
                                                        onChange={(option) => {
                                                            this.props.form.setFieldsValue({ idProductoSunat: undefined });
                                                            this.props.onChangeForm("idClaseSunat", option.key)
                                                        }}
                                                    >
                                                        {this.props.formValues.clasesSunat.map(item => (
                                                            <Option key={item.id} value={item.id}>{item.descripcion}</Option>
                                                        ))}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </div>

                                        <div className="col-md-12 form-group">
                                            <Form.Item label="Producto (SUNAT)">
                                                {getFieldDecorator('idProductoSunat', {
                                                    initialValue: this.props.formValues.idProductoSunat ?
                                                        { key: this.props.formValues.idProductoSunat } : undefined
                                                })(
                                                    <Select showSearch labelInValue
                                                        placeholder={"Seleccione Producto"}
                                                        optionFilterProp="children"
                                                    >
                                                        {this.props.formValues.productosSunat.map(item => (
                                                            <Option key={item.id} value={item.id}>{item.descripcion}</Option>
                                                        ))}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                            </TabPane>

                            <TabPane disabled={this.props.formValues.variante == 0 || this.props.formValues.id > 0 ? true : false} tab="Variantes" key="3">

                                <div className="row">
                                    <div className="col-md-8 form-group">
                                        <Form.Item label="Lista de Variantes">
                                            {getFieldDecorator('idVariantes', {
                                                initialValue: this.props.formValues.idVariantes
                                            })(
                                                <Select
                                                    mode="multiple"
                                                    placeholder={"Seleccione Variante"}
                                                    optionFilterProp="children"
                                                    onChange={(value) => this.props.onChangeForm("idVariantes", value, this.props.form)}
                                                >
                                                    {this.props.formValues.atributos.map(item => (
                                                        item.idTipoAtributo == 2 ?
                                                            <Option key={item.id} value={item.id} codigo={item.abreviatura}>{item.nombre + "-" + item.descripcion}</Option>
                                                            : null
                                                    ))}
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </div>
                                    <div className="col-md-4 form-group">
                                        <Form.Item label=".">
                                            <Button
                                                icon="plus"
                                                type="link"
                                                onClick={this.handleOpen}>
                                                Configuración de variante
                                            </Button>

                                        </Form.Item>

                                    </div>
                                    <div className="col-md-12 form-group">
                                        <Divider orientation="left"></Divider>
                                    </div>

                                    {this.props.formValues.varianteItemSelected.map((k, index) => (
                                        <div className="col-md-9 form-group">
                                            <Form.Item
                                                {...(index === 0 ? formItemLayout : formItemLayout)}
                                                label={k.nombre}
                                                required={false}
                                                key={k.identifier}
                                            >
                                                <InputGroup compact
                                                    key={k.identifier}
                                                >

                                                    {getFieldDecorator(`variant[${k.identifier}]`, {
                                                        validateTrigger: ['onChange'],
                                                        initialValue: "",
                                                        rules: [{
                                                            required: false,
                                                            message: "Campo obligatorio.",
                                                        }],
                                                    })(
                                                        <Input
                                                            placeholder="Ingresar Código de Barra"
                                                            style={{ width: `calc(80% - 40px)` }}

                                                        />
                                                    )}
                                                    <Tooltip placement="top" title={"Generar Codigo de Barra"}>
                                                        <Button
                                                            className="btn-autocomplete"
                                                            icon={'barcode'}
                                                            onClick={() => this.handleBarcode(k.identifier)}
                                                        />
                                                    </Tooltip>
                                                    <Tooltip placement="top" title="Eliminar">
                                                        <Button
                                                            type="danger"
                                                            icon="delete"
                                                            size={"small"}
                                                            style={{ marginLeft: 8, marginTop: 5 }}

                                                            onClick={() => this.props.onRemove(k)}
                                                        />
                                                    </Tooltip>

                                                </InputGroup>
                                            </Form.Item>
                                        </div>
                                    ))}

                                    {this.props.formValues.varianteItemSelected.length > 0 ?
                                        <div className="col-md-3 form-group">
                                            <Tooltip placement="top" title={"Generar Codigo de Barra"}>
                                                <Button
                                                    icon="barcode"
                                                    type="success"
                                                    onClick={() => this.props.handleGenerateBarcode(this.props.form)}>
                                                    Generar
                                                </Button>
                                            </Tooltip>

                                        </div>
                                        : null}


                                </div>
                            </TabPane>

                            <TabPane tab="Atributos Personalizados" key="4">
                                <div className="row">
                                    <div className="col-md-8 form-group">
                                        <Form.Item label="Lista de Atributos">
                                            {getFieldDecorator('idAtributo', {
                                                initialValue: this.props.formValues.idAtributo ?
                                                    { key: this.props.formValues.idAtributo } : undefined,
                                            })(
                                                <Select showSearch labelInValue
                                                    placeholder={"Seleccione Atributo"}
                                                    optionFilterProp="children"
                                                    onChange={(option, item) => {
                                                        this.handleonChange(option.key, item.props.codigo);
                                                    }}
                                                >
                                                    {this.props.formValues.atributos.map(item => (
                                                        item.idTipoAtributo == 1 ?
                                                            <Option key={item.id} value={item.id} codigo={item.abreviatura}>{item.nombre}</Option>
                                                            : null
                                                    ))}
                                                </Select>
                                            )}
                                        </Form.Item>

                                    </div>
                                    <div className="col-md-4 form-group">
                                        <Form.Item label=".">
                                            <Button
                                                icon="plus"
                                                type="primary"
                                                onClick={this.add}
                                                loading={this.props.formValues.addLoading}
                                            >
                                                Agregar
                                            </Button>

                                        </Form.Item>

                                    </div>
                                    <div className="col-md-12 form-group">
                                        <Divider orientation="left"></Divider>
                                    </div>
                                    {formItems}

                                </div>
                            </TabPane>


                        </Tabs>

                    </div>


                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)